import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { customerService, customerStatisticsService } from '../../_services'
import moment from 'moment'
import { Form, Button, Row, Col, Tabs, Tab, Spinner } from 'react-bootstrap'
import { Line } from 'react-chartjs-2'
import Select from 'react-select'
import { useParams } from 'react-router-dom';

function CustomerStatistics() {

	const {id} = useParams()
	const [customer, setCustomer] = useState(null)
	const [loading, setLoading] = useState(false)
	const [type, setType] = useState("documentations")
	const [data, setData] = useState(null)
	const [chartData, setChartData] = useState(null)
	const [cumulativeChartData, setCumulativeChartData] = useState(null)
	const {t} = useTranslation('common')
	const colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#00B3E6',
		  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
		  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
		  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
		  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
		  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
		  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
		  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
		  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
		  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']

    useEffect(() => {
        customerService.show(id).then(data => {
            setCustomer(data)
        })
    }, [])

    function handleTypeChange(e) {
        var type = e.target.value
        setType(type)
    }

    const run = (e) => {
        console.log('run')

        setLoading(true)
        customerStatisticsService.findAllTemplatesByCustomerId(id).then(templates => {
            templates.sort((a, b) => {
	            if (a.position != b.position) {
	                return a.position - b.position
	            }
	            return a.name.localeCompare(b.name)
	        })

            customerStatisticsService.findAllDocumentationsByCustomerId(id).then(documentations => {
	            var documentationMap = new Map()
	            documentations.forEach(documentation => {
	                //documentation.photos = []
	                documentation.photoCount = 0
	                documentation.dataSize = 0
	                documentationMap.set(documentation.id, documentation)
	            })

	            var minDate = documentations[0].dateCreated
		        documentations.forEach(documentation => {
		            if (documentation.dateCreated < minDate) {
		                minDate = documentation.dateCreated
		            }
		        })

	            customerStatisticsService.findAllPhotosByCustomerId(id).then(photos => {
	                photos.forEach(photo => {
	                    var documentation = documentationMap.get(photo.documentationId)
	                    if (documentation) {
	                        documentation.photoCount = photo.photoCount
	                        documentation.dataSize = photo.dataSize
	                        //documentation.photos.push(photo)
	                    }
	                })

		            console.log('starting data calculation')
		            var startTime = Date.now()

		            var data = []

					var row = ['Månad \\ Mall']
					templates.forEach(template => (
						row.push(template.name)
					))
					row.push('Total')
					data.push(row)

		            row = ['Totalt']
		            templates.forEach(template => {
	                    var statistics = getStatistics(documentations, photos, {template: template})
	                    row.push(statistics)
	                })
	                var statistics = getStatistics(documentations, photos, {})
	                row.push(statistics)
	                data.push(row)

	                var startDate = moment(minDate).startOf('month')
			        var months = []
			        while (startDate.isBefore()) {
			            months.push(startDate.toDate())
			            startDate.add(1, 'month')
			        }
			        var months = months.reverse()

		            months.forEach(month => {
		                var row = [moment(month).format("yyyy-MM")]
		                templates.forEach(template => {
		                    var statistics = getStatistics(documentations, photos, {month: month, template: template})
		                    row.push(statistics)
		                })
		                var statistics = getStatistics(documentations, photos, {month: month})
		                row.push(statistics)
		                data.push(row)
		            })
		            console.log(data)

		            setData(data)

		            console.log('data calculation: ' + (Date.now() - startTime) + ' ms')

		            setChartData(getChartData(templates, documentations, months))
		            setCumulativeChartData(getCumulativeChartData(templates, documentations, months))

		            setLoading(false)
		        })
	        })
        })
    }

    function getStatistics(documentations, photos, params) {
        if (type == 'documentations') {
            var filteredDocumentations = [...documentations]
	        if (params.month) {
	            var startDate = moment(params.month)
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return startDate.isSame(moment(documentation.dateCreated), 'month')
		        })
	        }
	        if (params.template != null) {
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return documentation.templateId == params.template.id
		        })
	        }
            return filteredDocumentations.length || '-'
        } else if (type == 'photos') {
            var filteredDocumentations = [...documentations]
	        if (params.month) {
	            var startDate = moment(params.month)
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return startDate.isSame(moment(documentation.dateCreated), 'month')
		        })
	        }
	        if (params.template != null) {
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return documentation.templateId == params.template.id
		        })
	        }
	        var numberOfPhotos = 0
            filteredDocumentations.forEach(documentation => {
                numberOfPhotos += documentation.photoCount
	        })
	        return numberOfPhotos || '-'
        } else if (type == 'datasize') {
            var filteredDocumentations = [...documentations]
	        if (params.month) {
	            var startDate = moment(params.month)
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return startDate.isSame(moment(documentation.dateCreated), 'month')
		        })
	        }
	        if (params.template != null) {
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return documentation.templateId == params.template.id
		        })
	        }
            var size = 0
            filteredDocumentations.forEach(documentation => {
                size += documentation.dataSize
//                documentation.photos.forEach(photo => {
//                    size += photo.dataSize
//                })
	        })
	        return formatSize(size)
        }
    }

    const formatSize = function(size) {
	    if (size) {
			var i = Math.floor( Math.log(size) / Math.log(1000) )
	        return ( size / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
	    }
        return '-'
    }

    const getChartOptions = () => {
        return {
	        maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    label: function(item, data) {
                        var result = data.datasets[item.datasetIndex].label + ': '
                        if (type == 'datasize') {
                            result += formatSize(item.yLabel)
                        } else {
                            result += item.yLabel
                        }
                        return result
                    }
                }
	        },
	        scales: {
	            xAxes: [{
	                type: 'time',
	                time: {
	                    unit: 'month',
	                    tooltipFormat: 'YYYY-MM',
	                    displayFormats: {
	                        millisecond: 'HH:mm:ss.SSS',
	                        second: 'HH:mm:ss',
	                        minute: 'HH:mm',
	                        hour: 'HH:mm',
	                    }
	                }
	            }],
	            yAxes: [{
	                ticks: {
	                    callback: function(label, index, labels) {
	                        if (type == 'datasize') {
	                            return formatSize(label)
	                        }
	                        return label
	                    }
	                }
	            }]
	        }
        }
    }

    const getChartData = (templates, documentations, months) => {
        console.log('getChartData')

        var months = months.toReversed()
        var datasets = []
        var tmp = [{
            id: null,
            name: t('customerstatistics.total')
        }]
        tmp.concat(templates).forEach(template => {
			var data = []
	        months.forEach(month => {
	            var filteredDocumentations = documentations.filter(documentation => {
		            return documentation.customerId == id
		        })
	            var startDate = moment(month)
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return startDate.isSame(moment(documentation.dateCreated), 'month')
		        })
		        if (template.id) {
			        filteredDocumentations = filteredDocumentations.filter(documentation => {
			            return documentation.templateId == template.id
			        })
		        }
		        if (type == 'documentations') {
		            data.push({x: month.getTime(), y: filteredDocumentations.length})
		        } else if (type == 'photos') {
					var numberOfPhotos = 0
		            filteredDocumentations.forEach(documentation => {
		                numberOfPhotos += documentation.photoCount
			        })
			        data.push({x: month.getTime(), y: numberOfPhotos})
		        } else if (type == 'datasize') {
					var size = 0
		            filteredDocumentations.forEach(documentation => {
		                size += documentation.dataSize
			        })
			        data.push({x: month.getTime(), y: size})
		        }
	        })
	        datasets.push({
	            label: template.name,
	            lineTension: 0,
	            data: data,
	            fill: false,
	            borderColor: colorArray[datasets.length],
	            pointBorderColor: colorArray[datasets.length],
	            pointBackgroundColor: colorArray[datasets.length]
	        })
        })
        return {datasets: datasets}
    }

    const getCumulativeChartData = (templates, documentations, months) => {
        console.log('getCumulativeChartData')

        var months = months.toReversed()
        var datasets = []
        var tmp = [{
            id: null,
            name: t('customerstatistics.total')
        }]
        tmp.concat(templates).forEach(template => {
			var data = []
			var value = 0
	        months.forEach(month => {
	            var filteredDocumentations = documentations.filter(documentation => {
		            return documentation.customerId == id
		        })
	            var startDate = moment(month)
	            filteredDocumentations = filteredDocumentations.filter(documentation => {
		            return startDate.isSame(moment(documentation.dateCreated), 'month')
		        })
		        if (template.id) {
			        filteredDocumentations = filteredDocumentations.filter(documentation => {
			            return documentation.templateId == template.id
			        })
		        }
		        if (type == 'documentations') {
		            value += filteredDocumentations.length
		            data.push({x: month.getTime(), y: value})
		        } else if (type == 'photos') {
					var numberOfPhotos = 0
		            filteredDocumentations.forEach(documentation => {
		                numberOfPhotos += documentation.photoCount
			        })
			        value += numberOfPhotos
			        data.push({x: month.getTime(), y: value})
		        } else if (type == 'datasize') {
					var dataSize = 0
		            filteredDocumentations.forEach(documentation => {
		                dataSize += documentation.dataSize
			        })
			        value += dataSize
			        data.push({x: month.getTime(), y: value})
		        }
	        })
	        datasets.push({
	            label: template.name,
	            lineTension: 0,
	            data: data,
	            fill: false,
	            borderColor: colorArray[datasets.length],
	            pointBorderColor: colorArray[datasets.length],
	            pointBackgroundColor: colorArray[datasets.length]
	        })
        })
        return {datasets: datasets}
    }

	return (
		<div>
			<h2>
				{ customer &&
					<>Statistik för {customer.name}</>
				}
            </h2>
            <Row>
	            <Col sm="3">
					<Form.Group controlId="type">
		                <Form.Label>
		                    {t('customerstatistics.type')}
		                </Form.Label>
						<Form.Control required as="select" name="type" value={type} onChange={handleTypeChange}>
		                    <option value="documentations">Antal dokumentationer</option>
		                    <option value="photos">Antal foton</option>
		                    <option value="datasize">Storlek</option>
		                </Form.Control>
		            </Form.Group>
                </Col>
            </Row>
            <Row style={{marginBottom: 20}}>
	            <Col sm="3">
					<Button variant="primary" onClick={run} disabled={loading}>
						{ !loading &&
							t('customerstatistics.run')
						}
						{ loading &&
							<>
								{t('customerstatistics.loading')}
								&nbsp;
								<Spinner animation="border" role="status" size="sm">
									<span className="sr-only">{t('customerstatistics.loading')}</span>
								</Spinner>
							</>
						}
					</Button>
                </Col>
            </Row>
            { !loading &&
                <>
                    { data &&
			            <Row>
			                <Col sm="12">
			                    <table className="table">
									<tbody>
										{ data.map((row, rowIndex) => (
											<tr key={'tr-' + rowIndex}>
												{ row.map((column, columnIndex) => (
													<td key={'td-' + rowIndex + '-' + columnIndex}>
														{column}
													</td>
												))}
											</tr>
										))}
									</tbody>
			                    </table>
			                </Col>
			            </Row>
		            }
		            <Row>
		                { chartData &&
			                <Col sm="12">
			                    <Line options={getChartOptions()} data={chartData} height={600} style={{height: 600}} />
			                </Col>
		                }
		                { cumulativeChartData &&
			                <Col sm="12">
			                    <Line options={getChartOptions()} data={cumulativeChartData} height={600} />
			                </Col>
		                }
		            </Row>
			    </>
            }
        </div>
    )
}

export default CustomerStatistics